import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjHorizon3DS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.25 8.58479C2.49228 8.58479 1 11.7151 1 11.7151L1 8.58479C3.24959 6.23567 7.18249 3.83415 10.9167 4.66958C13.25 5.19161 14.6111 7.06221 15 7.93226L15 12.5C15 12.5 10.0077 8.58479 6.25 8.58479Z"
        fill="currentcolor"
      />
    </svg>
  )
}

export const IconGeoObjHorizon3D = createIcon({
  l: IconGeoObjHorizon3DS,
  m: IconGeoObjHorizon3DS,
  s: IconGeoObjHorizon3DS,
  xs: IconGeoObjHorizon3DS,
  name: 'IconGeoObjHorizon3D',
})
